import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RecaptchaService } from '~/core/services/recaptcha.service';
import { from } from 'rxjs/observable/from';

@Injectable()
export class RecaptchaInterceptor implements HttpInterceptor {
  constructor(private recaptchaService: RecaptchaService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!this.shouldAddRecaptcha(request.url)) {
      return next.handle(request);
    }

    return from(this.recaptchaService.executeRecaptcha(this.getActionFromRequest(request))).pipe(
      switchMap(token => {
        const modifiedRequest = request.clone({
          setHeaders: {
            'g-recaptcha-response': token
          }
        });
        return next.handle(modifiedRequest);
      })
    );
  }

  private shouldAddRecaptcha(url: string): boolean {
    return url.includes('/rpdac/') && !this.isRecaptchaRelatedUrl(url);
  }

  private isRecaptchaRelatedUrl(url: string): boolean {
    const skipUrls = [
      '/api2/',
      'recaptcha'
    ];
    return skipUrls.some(skipUrl => url.includes(skipUrl));
  }

  private getActionFromRequest(request: HttpRequest<any>): string {
    const url = new URL(request.url);
    const pathParts = url.pathname.split('/');
    
    // Get the part after /rpdac/ to use as action name
    const rpdacIndex = pathParts.findIndex(part => part === 'rpdac');
    const actionPath = pathParts.slice(rpdacIndex + 1, rpdacIndex + 3).join('_');
    return `${request.method.toLowerCase()}_${actionPath}`;
  }
}


// WEBPACK FOOTER //
// ./src/app/captcha/interceptors/recaptcha.interceptor.ts